import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getInspectionAuthorityListQuery = params => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTION_AUTHORITIES}?${stringifyParams(params)}`
	);
};

export const getInspectionAuthorityList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTION_AUTHORITIES}?${stringifyParams(
			queryParams
		)}`
	);
};

export const getInspectionAuthority = inspection_authority_id => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTION_AUTHORITY}${inspection_authority_id}`
	);
};

export const addNewInspectionAuthorityApi = inspection_authority => {
	return apiClient.create(
		`${INSPECTION_BASE}${url.POST_INSPECTION_AUTHORITY}`,
		inspection_authority
	);
};

export const updateInspectionAuthorityApi = inspection_authority => {
	return apiClient.put(
		`${INSPECTION_BASE}${url.PUT_INSPECTION_AUTHORITY}${inspection_authority._id}`,
		inspection_authority
	);
};

export const deleteInspectionAuthorityApi = inspection_authority_id => {
	return apiClient.delete(
		`${INSPECTION_BASE}${url.DELETE_INSPECTION_AUTHORITY}${inspection_authority_id}`
	);
};

export const checkInspectionAuthorityExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${INSPECTION_BASE}${url.CHECK_INSPECTION_AUTHORITY_EXISTS}?${stringifyParams(
				queryParams
			)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
